import { render, staticRenderFns } from "./SMSHome.vue?vue&type=template&id=2c4afccb&"
import script from "./SMSHome.vue?vue&type=script&lang=ts&"
export * from "./SMSHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports